import { render, staticRenderFns } from "./SupplierFaqs.vue?vue&type=template&id=523f805a&"
import script from "./SupplierFaqs.vue?vue&type=script&lang=js&"
export * from "./SupplierFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports